import { resolveFirebaseEnv } from '../firebase.config.js';

const CMS_APP_URLS = {
  production: 'https://admin.bildit.co',
  staging: 'https://admin-staging.bildit.co',
  dev: 'https://admin-dev.bildit.co',
  localhost: 'http://localhost:3001',
};

/**
 * CMS login / app origin for the current frontend env.
 * Mirrors functions/config.js cmsAppUrl:
 *   signup.bildit.co       → https://admin.bildit.co
 *   dev.signup.bildit.co   → https://admin-dev.bildit.co
 *   stage.signup.bildit.co → https://admin-staging.bildit.co
 * Override with REACT_APP_CMS_APP_URL when needed.
 * @param {string} [firebaseEnv]
 * @returns {string}
 */
export function getCmsAppUrl(firebaseEnv = resolveFirebaseEnv()) {
  const override = String(process.env.REACT_APP_CMS_APP_URL || '').trim();
  if (override) {
    return override.replace(/\/$/, '');
  }

  if (firebaseEnv === 'staging') {
    return CMS_APP_URLS.staging;
  }
  if (firebaseEnv === 'dev') {
    return CMS_APP_URLS.dev;
  }
  if (firebaseEnv === 'localhost') {
    return CMS_APP_URLS.localhost;
  }
  return CMS_APP_URLS.production;
}
